BinderBonuses = window.BinderBonuses = (function () {
    var bindUI = function () {
        return false;

    }
    var unBindUI = function () {
        return false;
    }

    var bind = function (justLoaded) { bindUI(); };
    var unBind = function () { unBindUI(); };

    return {
        bind: bind,
        unBind: unBind,
        name: 'BinderBonuses',
        url: '/Bonuses/GetViewSet'
    };
}());

//-----------------------------------

ScopeBonuses = (function () {

    function init() {
        app.VerticalMenu.hide();
    }

    function dispose() {
        return;
    }

    var start = function (justLoaded) { init(); };
    var stop = function () { dispose(); };

    return {
        start: start,
        stop: stop,
        name: 'ScopeBonuses',
        title: Localization.getString('Shared.Bonuses','Бонусы'),
        isLayoutRightColumnVisible: false
    };
}());